<script setup lang="ts">
  const props = withDefaults(
    defineProps<{
      date?: string | null;
      variant?: 'default' | 'tag';
    }>(),
    {
      date: '',
      variant: 'default',
    },
  );

  const dateLabel = computed(() => {
    if (!props.date) return '';
    const parsed = new Date(props.date);
    if (Number.isNaN(parsed.getTime())) return '';

    const day = parsed.toLocaleDateString('pt-BR', { day: '2-digit' });
    const month = parsed.toLocaleDateString('pt-BR', { month: 'long' });
    return `${day} de ${month[0].toUpperCase()}${month.slice(1)}`;
  });
</script>

<template>
  <span v-if="variant === 'tag'" class="pre-sale-pill">
    Pré-venda
  </span>

  <span v-else class="pre-sale">
    <span class="pre-sale__label">Pré-venda</span>
    <span v-if="dateLabel" class="pre-sale__details">
      - Disponível a partir de {{ dateLabel }}
    </span>
  </span>
</template>

<style lang="scss" scoped>
  .pre-sale {
    @apply inline-flex max-w-full items-center justify-center self-start;
    @apply rounded-full bg-feedback-warning-light px-micro py-quark;
    @apply text-feedback-warning-dark leading-[1.15];
  }

  .pre-sale__label {
    @apply font-highlight text-micro;
    font-style: italic;
    font-weight: 500;
  }

  .pre-sale__details {
    @apply fonts-body-small-regular text-micro;
  }

  .pre-sale-pill {
    @apply inline-flex items-center justify-center gap-quark;
    @apply whitespace-nowrap rounded-full px-micro py-quark;
    @apply bg-feedback-warning-light text-feedback-warning-dark;
    @apply font-highlight text-micro leading-xs;
    font-style: italic;
    font-weight: 500;
  }
</style>
